import React, { PureComponent } from 'react';
import { get } from 'lodash/fp';
import { connect } from 'react-redux';
import { TYPES } from 'constants/config';
import * as actions from '../../../actions/pathBuilder/contents';
import * as selectors from '../../../selectors/pathBuilder';
import { humanizeContentType } from '../utils';
import Picker from '../Picker';
import ContentRenderer from './ContentRenderer';
import DueDateForm from './DueDateForm';
import ContentWrapper from './ContentWrapper';

class Content extends PureComponent {
  constructor() {
    super();
    this.onContentPickerChange = this.onContentPickerChange.bind(this);
    this.getOptions = this.getOptions.bind(this);
  }

  getOptions() {
    const { type, dueIn, remove, toggleEditing, toggleEditingDueDate } =
      this.props;
    const options = [
      {
        label: 'Delete',
        icon: 'delete',
        onClick: remove,
      },
    ];

    if (type === TYPES.LESSON || type === TYPES.PATH) {
      options.push({
        label: 'Edit Selection',
        icon: 'edit',
        onClick: toggleEditing,
      });
    }

    if (dueIn) {
      options.push({
        label: 'Edit Due Date',
        icon: 'calendar_empty',
        onClick: toggleEditingDueDate,
      });
    }

    return options;
  }

  onContentPickerChange(content) {
    this.props.update(content);
    this.props.toggleEditing();
    if (this.props.justAdded) {
      this.props.persist(content.id, content.type);
    }
  }

  render() {
    const {
      id,
      type,
      position,
      viewState,
      stepNumber,
      isCertification,
      ...props
    } = this.props;
    const wrapperProps = { id, type, position, stepNumber };
    return (
      <ContentWrapper {...wrapperProps} showStep={type !== TYPES.PATH}>
        {viewState === 'editing' && (
          <Picker
            type={isCertification ? TYPES.CERTIFICATION : type}
            pathId={props.pathId}
            title={`Select a ${humanizeContentType(type, isCertification)}`}
            onChange={this.onContentPickerChange}
            onCancel={this.props.cancelEditing}
          />
        )}
        {viewState === 'normal' && (
          <ContentRenderer {...this.props} options={this.getOptions()} />
        )}
        {viewState === 'dueDate' && (
          <DueDateForm
            {...this.props}
            defaultAmount={get('amount', props.dueIn)}
            defaultUnit={get('unit', props.dueIn)}
            updateContent={props.update}
            toggleEditingDueDate={props.toggleEditingDueDate}
          />
        )}
      </ContentWrapper>
    );
  }
}

const mapStateToProps = ({ pathBuilder }) => {
  const isJustAdded = selectors.isJustAdded();
  const getStepNumber = selectors.getStepNumber();
  const getViewState = selectors.getContentViewState();
  const isLoadingContents = selectors.isLoadingContent();
  return (state, props) => ({
    viewState: getViewState(state.pathBuilder, props),
    justAdded: isJustAdded(state.pathBuilder, props),
    stepNumber: getStepNumber(state.pathBuilder, props),
    pathId: state.pathBuilder.id,
    loading: isLoadingContents(state.pathBuilder, props),
    isCertification: selectors.isAddingCertification(state.pathBuilder, props),
  });
};

const mapDispatchToProps = (dispatch, { id, type, position, justAdded }) => ({
  update: change => dispatch(actions.update(id, type, change)),
  persist: (contentId, contentType) =>
    dispatch(actions.persist(contentId, contentType)),
  remove: () => dispatch(actions.remove(id, type)),
  toggleEditing: () => dispatch(actions.toggleEditing(id, type)),
  toggleEditingDueDate: () =>
    dispatch(actions.toggleEditing(id, type, 'dueDate')),
  cancelEditing: () => dispatch(actions.cancelEditing(id, type, justAdded)),
  fetchContents: () => dispatch(actions.fetchContents(id, type)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Content);
